import { Col, Collapse, Divider, Row } from "antd"
import {
    WechatOutlined,
    // WeiboCircleOutlined,
    // QqOutlined
} from '@ant-design/icons';

import iconFooter from '../../assets/foot-ga.png'

import '../front/style.scss'

const Footer = props => {

    const content = [
        {
            key: 1,
            label: '总部地址',
            children: <>
                <p>浙江省杭州市余杭区</p>
                <p>五常街道云汇城9-3号</p>
            </>
        },
        {
            key: 2,
            label: '联系我们',
            children: <>
                <p>热线电话：15700086939</p>
                <p>服务时间：9:00 - 18:00</p>
            </>
        },
        {
            key: 3,
            label: '在线平台',
            children: <>
                <p><WechatOutlined />&nbsp;微信：15700086939</p>
                {/* <p><WeiboCircleOutlined />&nbsp;微博：xxxxxxxxxx</p>
                <p><QqOutlined />&nbsp;QQ：xxxxxxxx</p> */}
            </>
        },
        {
            key: 4,
            label: '关于',
            children: <>
                <p
                    onClick={() => window.location.href = '/'}
                    style={{ textDecoration: 'underline', cursor: 'pointer' }}
                >
                    关于我们
                </p>
            </>
        },

    ]

    return <div className="footer">
        <div className="pc">
            <Row justify="space-around" align="top">
                {content.map(i => <Col key={i.label}>
                    <h2>{i.label}</h2>
                    <div>{i.children}</div>
                </Col>)}
            </Row>
        </div>
        <div className="phone">
            <Collapse items={content} bordered={false} />
        </div>
        <Divider />
        <div className="ipc">
            <div
                style={{ marginRight: '8px' }}
                onClick={() => window.open("https://beian.miit.gov.cn/")}
            >
                浙ICP备2025196956号-1
            </div>
            <img src={iconFooter} alt="" />
            <div
                onClick={() => window.open("https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33011002018404")}
            >浙公网安备33011002018404号</div>
            ©九尾陆吾(杭州)智能科技有限公司
        </div>
    </div>
}

export default Footer
